import * as React from "react";

const SvgComponent = (props) => (
    <svg style={{ margin: '0 4px 4px 0' }} width="15" height="15" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9844 0.556152C8.21 0.589624 5.55869 1.70662 3.59676 3.66854C1.63484 5.63046 0.517847 8.28178 0.484375 11.0562C0.517847 13.8305 1.63484 16.4818 3.59676 18.4438C5.55869 20.4057 8.21 21.5227 10.9844 21.5562C13.7588 21.5227 16.4101 20.4057 18.372 18.4438C20.3339 16.4818 21.4509 13.8305 21.4844 11.0562C21.4509 8.28178 20.3339 5.63046 18.372 3.66854C16.4101 1.70662 13.7588 0.589624 10.9844 0.556152ZM16.9844 11.8062H11.7344V17.0562H10.2344V11.8062H4.98438V10.3062H10.2344V5.05615H11.7344V10.3062H16.9844V11.8062Z" fill="white" />
    </svg>

);

export default SvgComponent;